import { firestore } from "../firebase"

export const fetchBlog = async () => {
	return new Promise(async (resolve, reject) => {
		try {
			const snapshot = await firestore
				.collection("articles")
				.orderBy("date", "desc")
				.get()

			const snapshotsData = snapshot.docs.map(doc => doc.data())

			resolve(snapshotsData)
		} catch (error) {
			console.error(error)
			reject(error)
		}
	})
}

export const getArticles = state => state.blog

export const getArticle = (state, id) => state.blog[id?.split("-")?.pop()]

const blogReducer = (state = [], action) => {
	const { type, blog } = action

	switch (type) {
		case "SET_BLOG":
			return blog

		default:
			return state
	}
}

export default blogReducer
